const paletteRed = {
  primary: {
    main: "#f44336",
    light: "#42a5f5",
    dark: "#1565c0",
    contrastText: "#fff",
  },
  secondary: {
    main: "#30bdc4",
    light: "#e4f1f9",
    dark: "#001f54",
    contrastText: "#fff",
  },
};

export default paletteRed;
